export default __webpack_public_path__ + "static/media/49_1_1.4967055a.png";